export default "/_next/static/images/576d2a96f0c0488613f4d7bd818fef78.jpg";